<template>
    <Field v-bind="$props">
        <AntInputPassword
            :id="name"
            v-model="innerValue"
            :class="elementClasses"
            v-bind="$attrs"
            @blur="$emit('blur')"
        />
    </Field>
</template>

<script>
import Field from '@/components/field/Field.vue';
import { Input } from 'ant-design-vue';
import fieldMixin from '@/mixins/fieldMixin';
export default {
    components: {
        AntInputPassword: Input.Password,
        Field,
    },
    mixins: [fieldMixin],
};
</script>

<style></style>
